import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"card export-wrap\"><div class=\"row align-items-center\"><div class=\"col-sm-10\"><h1 class=\"title mb-2\">All Business Mail Log List</h1><p class=\"mb-sm-0\"><small>Business Mail Log List.</small></p></div></div></div>", 1)
const _hoisted_2 = { class: "card p-0" }
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table table-shadowed table-relative mb-0" }
const _hoisted_5 = /*#__PURE__*/_createVNode("thead", { class: "table-primary" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { scope: "col" }, " S.N. "),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Subject"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Sent"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Mail Count"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Action")
  ])
], -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "mail-count" }
const _hoisted_8 = { title: "Total Mail" }
const _hoisted_9 = {
  class: "success-mail",
  title: "Success"
}
const _hoisted_10 = {
  class: "failed-mail",
  title: "Failed"
}
const _hoisted_11 = { class: "file-actions position-relative" }
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "fas fa-envelope-open" }, null, -1)
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { colspan: "5" }
const _hoisted_16 = {
  key: 2,
  class: "table-loader chat-load"
}
const _hoisted_17 = { class: "modal-wrap default-modal" }
const _hoisted_18 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "sendMail",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_19 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_20 = { class: "modal-content" }
const _hoisted_21 = { class: "modal-header" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "d-block" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, "Select Mail"),
  /*#__PURE__*/_createVNode("p", { class: "text-muted" }, "Select and ReSend Mail ")
], -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_24 = { class: "modal-body" }
const _hoisted_25 = /*#__PURE__*/_createVNode("p", null, "Click on the email ids below and choose to whom you want to resend the email. ", -1)
const _hoisted_26 = { class: "card p-0" }
const _hoisted_27 = { class: "table-responsive" }
const _hoisted_28 = { class: "table table-shadowed table-relative mb-0" }
const _hoisted_29 = { class: "table-primary" }
const _hoisted_30 = { scope: "col" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Email ")
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "mb-0" }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { colspan: "5" }
const _hoisted_36 = {
  key: 2,
  class: "table-loader chat-load"
}
const _hoisted_37 = {
  key: 0,
  class: "modal-footer"
}
const _hoisted_38 = { class: "modal-wrap default-modal" }
const _hoisted_39 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "mailTemplate",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_40 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_41 = { class: "modal-content" }
const _hoisted_42 = { class: "card p-0 modal-newsletter" }
const _hoisted_43 = { class: "table-responsive" }
const _hoisted_44 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyData = _resolveComponent("EmptyData")
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("table", _hoisted_4, [
          _hoisted_5,
          (_ctx.state.mailLogList.length)
            ? (_openBlock(), _createBlock("tbody", _hoisted_6, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.mailLogList, (template, templateIndex) => {
                  return (_openBlock(), _createBlock("tr", { key: templateIndex }, [
                    _createVNode("td", null, _toDisplayString(templateIndex+1), 1),
                    _createVNode("td", null, _toDisplayString(template.subject), 1),
                    _createVNode("td", null, _toDisplayString(template.created_at), 1),
                    _createVNode("td", null, [
                      _createVNode("div", _hoisted_7, [
                        _createVNode("ul", null, [
                          _createVNode("li", _hoisted_8, _toDisplayString(template.total), 1),
                          _createVNode("li", _hoisted_9, _toDisplayString(template.total-template.log_user.length), 1),
                          _createVNode("li", _hoisted_10, _toDisplayString(template.log_user.length), 1)
                        ])
                      ])
                    ]),
                    _createVNode("td", null, [
                      _createVNode("div", _hoisted_11, [
                        _createVNode("a", {
                          href: "javascript:void(0)",
                          title: "View",
                          onClick: ($event: any) => (_ctx.showMailTemplate(template))
                        }, [
                          _hoisted_12
                        ], 8, ["onClick"]),
                        _createVNode("a", {
                          class: "not-sent-email",
                          title: "Mail not sent due to error",
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.showSendMail(template))
                        }, [
                          _hoisted_13
                        ], 8, ["onClick"])
                      ])
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createBlock("tfoot", _hoisted_14, [
                _createVNode("tr", null, [
                  _createVNode("td", _hoisted_15, [
                    _createVNode(_component_EmptyData, {
                      title: _ctx.state.data.title,
                      heading: _ctx.state.data.heading
                    }, null, 8, ["title", "heading"])
                  ])
                ])
              ])),
          (_ctx.state.ui.isPostLoading.getUserActivityList)
            ? (_openBlock(), _createBlock("div", _hoisted_16, [
                _createVNode("img", {
                  src: 
                _ctx.state.data.imageBaseUrl
                  ? `${_ctx.state.data.imageBaseUrl}img/chat-loading.gif`
                  : 'img/chat-loading.gif'
              ,
                  alt: ""
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_17, [
      _createVNode("div", _hoisted_18, [
        _createVNode("div", _hoisted_19, [
          _createVNode("div", _hoisted_20, [
            _createVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideSendMail && _ctx.hideSendMail(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_23
              ])
            ]),
            _createVNode("div", _hoisted_24, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.errorList,
                hasError: _ctx.state.ui.hasErrorStatus
              }, null, 8, ["errors", "hasError"]),
              _hoisted_25
            ]),
            _createVNode("div", _hoisted_26, [
              _createVNode("div", _hoisted_27, [
                _createVNode("table", _hoisted_28, [
                  _createVNode("thead", _hoisted_29, [
                    _createVNode("tr", null, [
                      _createVNode("th", _hoisted_30, [
                        _withDirectives(_createVNode("input", {
                          class: "mr-2",
                          type: "checkbox",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.checkAll())),
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.isCheckedAll = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.state.isCheckedAll]
                        ]),
                        _hoisted_31
                      ])
                    ])
                  ]),
                  (_ctx.state.userList.length)
                    ? (_openBlock(), _createBlock("tbody", _hoisted_32, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.userList, (user, userIndex) => {
                          return (_openBlock(), _createBlock("tr", { key: userIndex }, [
                            _createVNode("td", null, [
                              _createVNode("p", _hoisted_33, [
                                _withDirectives(_createVNode("input", {
                                  class: "mr-2",
                                  type: "checkbox",
                                  value: user.user_id,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.checkUser = $event)),
                                  onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.updateCheckall && _ctx.updateCheckall(...args)))
                                }, null, 40, ["value"]), [
                                  [_vModelCheckbox, _ctx.state.checkUser]
                                ]),
                                _createTextVNode(" " + _toDisplayString(user.email), 1)
                              ])
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createBlock("tfoot", _hoisted_34, [
                        _createVNode("tr", null, [
                          _createVNode("td", _hoisted_35, [
                            _createVNode(_component_EmptyData, {
                              title: _ctx.state.data.title,
                              heading: _ctx.state.data.heading
                            }, null, 8, ["title", "heading"])
                          ])
                        ])
                      ])),
                  (_ctx.state.ui.isPostLoading.getUserActivityList)
                    ? (_openBlock(), _createBlock("div", _hoisted_36, [
                        _createVNode("img", {
                          src: 
                        _ctx.state.data.imageBaseUrl
                          ? `${_ctx.state.data.imageBaseUrl}img/chat-loading.gif`
                          : 'img/chat-loading.gif'
                      ,
                          alt: ""
                        }, null, 8, ["src"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (_ctx.state.isSentMail)
              ? (_openBlock(), _createBlock("div", _hoisted_37, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.sendMail && _ctx.sendMail(...args)))
                  }, " Send ")
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 0,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_38, [
      _createVNode("div", _hoisted_39, [
        _createVNode("div", _hoisted_40, [
          _createVNode("div", _hoisted_41, [
            _createVNode("div", _hoisted_42, [
              _createVNode("div", _hoisted_43, [
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.hideMailTemplate && _ctx.hideMailTemplate(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_44
                ]),
                _createVNode("div", {
                  innerHTML: _ctx.state.mailMessage
                }, null, 8, ["innerHTML"])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}